<!-- src/components/Sidebar.vue -->
<template>
  <!-- 过渡动画：控制侧边栏宽度变化 -->
  <transition name="sidebar-fade">
    <div
      class="sidebar-container"
      :style="{ width: isHide ? '0px' : '190PX' }"
    >
      <!-- 顶部Logo区域 -->
      <div class="sidebar-logo">
        <div class="logo-icon">
          <img src="../assets/image/logo2.png" alt="">
        </div>
      </div>

      <!-- 导航菜单区域 -->
      <ul class="sidebar-menu">
        <li
          v-for="(item, index) in menuList"
          :key="index"
          class="menu-item"
          :class="{ 'menu-active': $route.path.startsWith(item.path) }"
        >
          <div
            class="menu-link"
          >
            <img :src="$route.path.startsWith(item.path) ? item.aIcon : item.icon" alt="" class="menu-icon">
            <span v-show="!isHide" class="menu-label" @click="handleMenuClick(item.path)">{{ item.label }}</span>
            <i :class="item.isOpen ? 'el-icon-arrow-up': 'el-icon-arrow-down'" v-if="item.children" @click="item.isOpen = !item.isOpen"></i>
          </div>
          <!-- 子菜单 -->
          <ul class="submenu-list" v-if="item.isOpen">
            <li
              v-for="(child, index) in item.children"
              :key="index"
              class="submenu-item"
              :class="{ 'is-active': $route.path.startsWith(child.path) }"
              @click="handleMenuClick(child.path)"
            >
              <span v-show="!isHide" class="menu-label">{{ child.label }}</span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Sidebar',
  // 接收父组件传递的折叠状态
  props: {
    isHide: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // 菜单列表：配置label（名称）、icon（图标）、path（路由路径）
      menuList: [
        { label: '首页', icon: require('../assets/image/bar/home.png'), aIcon: require('../assets/image/bar/ahome.png'), path: '/home' },
        { label: '企业全景', icon: require('../assets/image/bar/enterprise.png'), aIcon: require('../assets/image/bar/aenterprise.png'), path: '/enterprise',
          isOpen: false,
          children: [
            { label: '企业信息', path: '/enterpriseInfo' },
            { label: '企业荣誉', path: '/enterpriseHonor' },
            { label: '合作伙伴', path: '/enterprisePartner' },
            { label: '图片展示', path: '/enterpriseSwiper' }
          ]},
        { label: '流程视窗', icon: require('../assets/image/bar/process.png'), aIcon: require('../assets/image/bar/aprocess.png'), path: '/process',
          isOpen: false,
          children: [
            { label: '项目流程', path: '/process/processProject' },
            { label: '内部流程', path: '/process/processFlow' }
          ]},
        { label: '知识云图', icon: require('../assets/image/bar/knowledge.png'), aIcon: require('../assets/image/bar/aknowledge.png'), path: '/knowledge' },
        { label: '项目智能体', icon: require('../assets/image/bar/agent.png'), aIcon: require('../assets/image/bar/aagent.png'), path: '/agent' },
        { label: '档案跟踪', icon: require('../assets/image/bar/archive.png'), aIcon: require('../assets/image/bar/aarchive.png'), path: '/archive' },
        { label: '服务监督', icon: require('../assets/image/bar/supervision.png'), aIcon: require('../assets/image/bar/asupervision.png'), path: '/supervision' },
        { label: '服务评价', icon: require('../assets/image/bar/evaluate.png'), aIcon: require('../assets/image/bar/aevaluate.png'), path: '/evaluate' },
        { label: '政策要点', icon: require('../assets/image/bar/policy.png'), aIcon: require('../assets/image/bar/apolicy.png'), path: '/policy' },
        { label: '项目展示', icon: require('../assets/image/bar/project.png'), aIcon: require('../assets/image/bar/aproject.png'), path: '/project' }
      ]
    }
  },
  methods: {
    // 点击菜单跳转路由
    handleMenuClick (path) {
      if(path){
        this.$router.push(path)
      }
    }
  }
}
</script>

<style scoped lang="scss">
/* 侧边栏容器样式 */
.sidebar-container {
  height: 100vh;
  background: linear-gradient(to bottom, #C5D8FF 0%, #F4F5F9 32%, #F4F5F9 83%, #DEE9FF 100%);
  box-shadow: 0px 0px 10px 0px #86b6dd, inset 2px 0px 0px 0px #FFFFFF;
  border-radius: 0px 50px 50px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  position: fixed; /* 固定侧边栏 */
  left: 0;
  top: 0;
  z-index: 99;
  /* 过渡动画：宽度变化 */
  transition: width 0.3s ease;
  overflow: hidden;
  border: 2px solid #fff;
  border-left: 0;
}

/* Logo样式 */
.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 30px;
  width: 100%;
  justify-content: center;
}
.logo-icon {
  width: 76px;
  height: 66px;
  img{
    width: 100%;
    height: 100%;
  }
}
.logo-text {
  font-size: 16px;
  font-weight: bold;
  color: #1f2937;
}

/* 菜单列表样式 */
.sidebar-menu {
  list-style: none;
  padding: 0;
  width: 100%;
}
.sidebar-menu li {
  width: 100%;

  .menu-link {
    height: 50px;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    margin: 5px 0;
    padding: 0 10px;
    font-weight: 500;
    font-size: 24px;
    color: #08141D;
    line-height: 18px;
    text-align: left;
  }
}
/* 展开时菜单左对齐 */
.sidebar-container:not([style*="width: 60px"]) .sidebar-menu li {
  justify-content: flex-start;
}
.sidebar-menu li i {
  font-size: 20px;
}
.menu-icon{
  width: 25px;
  height: 25px;
}
.menu-label {
  font-size: 20px;
}

/* 激活态样式 */
.menu-active {
  .menu-link {
    width: 90% !important;
    background: #008DFF;
    color: #fff !important;
    box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
    border-radius: 0 30px 30px 0;
  }
}

/* 鼠标悬浮样式 */
.sidebar-menu li:hover:not(.menu-active) {
  color: #409EFF;
  background: rgba(64, 158, 255, 0.1);
}
/* 子菜单样式 */
.submenu-list {
  list-style: none;
  padding: 0;
  width: 85%;
  margin: 0 auto 10px;

  .submenu-item {
    height: 40px;
    line-height: 40px;
    padding-left: 15px;
    cursor: pointer;
    color: #08141D;
    font-size: 16px;
    transition: all 0.2s ease;
    margin-bottom: 10px;

    &.is-active {
      width: 90% !important;
      background: #008DFF;
      color: #fff !important;
      box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
      border-radius: 0 30px 30px 0;
    }
  }
}
/* 过渡动画样式 */
.sidebar-fade-enter-active, .sidebar-fade-leave-active {
  transition: all 0.3s ease;
}
.sidebar-fade-enter, .sidebar-fade-leave-to {
  opacity: 0;
  width: 0;
}
</style>
